// extracted by mini-css-extract-plugin
module.exports = {"root":"TableHeading_root__m3KVA","clinicsSelect":"TableHeading_clinicsSelect__3wfCv"};